import React from 'react'
import sm1 from '../media/sm1.jpg'
import sm2 from '../media/sm2.png'
import sm3 from '../media/sm3.jpg'
import sm4 from '../media/sm4.jpg'
import { Link } from 'react-router-dom'
export default function FollowUs() {
    return (
        <div className='follow-us container' style={{paddingBottom:'90px'}}>
            <div className='text-center' style={{fontSize:'30px', fontWeight:'500', marginBottom:'75px', color:'rgb(95, 91, 87)'}}>
                <Link to="https://www.instagram.com/kidorise9?igsh=MXN5NHE1Z282c3lvZQ%3D%3D" target="_blank" rel="noopener noreferrer" style={{fontSize:'30px', fontWeight:'500'}}>
                Follow Us on @kidorise9
                </Link>
            </div>
            <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                    <div>
                        <img className='follow-img' src={sm1} alt="" />
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                    <div>
                        <img className='follow-img' src={sm2} alt="" />
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                    <div>
                        <img className='follow-img' src={sm3} alt="" />
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                    <div>
                        <img className='follow-img' src={sm4} alt="" />
                    </div>
                </div>
            </div>

        </div>
    )
}
